import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDNXKmgKt4qu5SAPzD7_TJxE10NE2H1gTg",
  authDomain: "contabilidad-vb.firebaseapp.com",
  databaseURL: "https://contabilidad-vb-default-rtdb.firebaseio.com",
  projectId: "contabilidad-vb",
  storageBucket: "contabilidad-vb.firebasestorage.app",
  messagingSenderId: "600242132942",
  appId: "1:600242132942:web:5335e5b48ffd67821d3d9f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
const db_firestore = getFirestore(app);

export { db, db_firestore };
